var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ks-display-block pt-1 pl-4"},[_c('kst-image',{attrs:{"is-public":"","brand-img":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }